import styles from './condeNast.module.scss';

const is24Chars = /^[a-z0-9]{24}$/;

const CondeNast = (props: IProps) => {
	const { value } = props;
	const { videoID } = value;

	const videoUrl = `//player.cnevids.com/iframe/video/${videoID}?iu=%2F3379%2Fconde.vogue%2Fplayer&adsDisabled=true&autoplay=1`;

	if (!is24Chars.test(videoID)) {
		return;
	}

	return (
		<div>
			<iframe
				allowFullScreen={true}
				allow="fullscreen"
				src={videoUrl}
				className={styles.condeNastPlayer}
				style={{ width: '100%' }}
			></iframe>
		</div>
	);
};

interface IProps {
	value: {
		videoID: string;
	};
}

export default CondeNast;
